export default __webpack_public_path__ + "static/media/no_course_logo.5533b14a.jpg";